import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { LOGO_URL } from "@/data/brand";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Se l'email è registrata, riceverai le istruzioni per il reset.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-20" data-testid="forgot-password-page">
      <Link to="/"><img src={LOGO_URL} alt="HostMarket" className="h-10 w-auto mb-10" /></Link>
      <h1 className="font-heading font-black text-3xl mb-2">Password dimenticata?</h1>
      <p className="text-sm text-zinc-500 mb-8">Inserisci la tua email. Ti invieremo un link per reimpostarla.</p>
      {sent ? (
        <div className="hm-card p-6 text-sm text-zinc-300" data-testid="forgot-sent">
          <i className="fas fa-envelope-circle-check text-3xl text-[#22C55E] mb-3"></i>
          <p>Se l'email è registrata, riceverai a breve le istruzioni per il reset della password.</p>
          <Link to="/login" className="text-[#FFBE00] hover:underline text-xs uppercase tracking-wider mt-4 inline-block">← Torna al login</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <label className="text-xs uppercase tracking-wider text-zinc-500 mb-2 block">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#0A0A0A] border border-zinc-800 rounded-md px-4 py-3 text-sm focus:border-[#FFBE00] focus:ring-1 focus:ring-[#FFBE00] outline-none" data-testid="forgot-email" />
          </div>
          <button type="submit" disabled={loading} className="w-full py-3 rounded-md bg-[#FFBE00] text-black font-bold uppercase tracking-wider text-sm hover:bg-[#E619A8] hover:text-white transition-all disabled:opacity-50" data-testid="forgot-submit">
            {loading ? "Invio…" : "Invia link reset"}
          </button>
          <div className="text-center text-sm text-zinc-500"><Link to="/login" className="hover:text-[#FFBE00]">Accedi</Link> · <Link to="/registrati" className="hover:text-[#E619A8]">Registrati</Link></div>
        </form>
      )}
    </div>
  );
}
